export const disableHoverOnTouch = () => {
  // タッチデバイス判定
  const touch = 'ontouchstart' in document.documentElement
    || navigator.maxTouchPoints > 0
    || navigator.msMaxTouchPoints > 0;

  if (touch) {
    // すべての:hoverルールを削除
    try {
      for (const si in document.styleSheets) {
        const styleSheet = document.styleSheets[si];
        if (!styleSheet.rules) continue;

        for (let ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.rules[ri].selectorText) continue;

          if (styleSheet.rules[ri].selectorText.match(':hover')) {
            styleSheet.deleteRule(ri);
          }
        }
      }
    } catch (ex) {
      // CORSエラーや権限エラーを無視
    }
  }
};

// メディアクエリでホバー機能の有無を検出
export const detectHoverSupport = () => {
  const hasHoverSupport = window.matchMedia('(hover: hover)').matches;

  if (!hasHoverSupport) {
    // ホバーサポートなしの場合、ホバールールを削除
    try {
      for (const si in document.styleSheets) {
        const styleSheet = document.styleSheets[si];
        if (!styleSheet.rules) continue;

        for (let ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.rules[ri].selectorText) continue;

          if (styleSheet.rules[ri].selectorText.match(':hover')) {
            styleSheet.deleteRule(ri);
          }
        }
      }
    } catch (ex) {
      // CORSエラーや権限エラーを無視
    }
  }

  return hasHoverSupport;
};

// 初期化関数
export const initTouchDeviceDetection = () => {
  // スタイルシートが読み込まれた後に実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // スタイルシート読み込み完了を待つ
      setTimeout(() => {
        disableHoverOnTouch();
        detectHoverSupport();
      }, 100);
    });
  } else {
    disableHoverOnTouch();
    detectHoverSupport();
  }
};